import { getScript } from './get-resource';
const sitekey = window.environment === 'development' ? 'FCMMLI4F36OPNVE5' : 'FCMMLI4F3764Q8G9';
const puzzleEndpoint = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle';
const solutionFieldName = 'captcha_solution';
const recaptchaSiteKey = '6LeXNpQrAAAAAE8H0stb67KVzlioMTWeuGdr_OlC';
let recaptchaLoaded = false;
export const captchaWidgets = new Map();
const captchaSolvedCallback = (captchaContainer) => {
    toggleCaptchaSolved(captchaContainer, true);
    toggleSubmitButton(captchaContainer, true);
};
export const resetCaptcha = (captchaContainer) => {
    if (!captchaWidgets.has(captchaContainer.id)) {
        return;
    }
    const captchaWidget = captchaWidgets.get(captchaContainer.id);
    toggleCaptchaSolved(captchaContainer, false);
    toggleSubmitButton(captchaContainer, false);
    captchaWidget.reset();
    captchaWidget.start();
};
const toggleCaptchaSolved = (captchaContainer, solved) => {
    captchaContainer.classList.toggle('captcha-solved', solved);
};
const toggleSubmitButton = (captchaContainer, enabled) => {
    const submitButton = captchaContainer.parentElement?.querySelector('input[type="submit"], button[type="submit"]');
    if (!submitButton) {
        return;
    }
    enabled ? submitButton.removeAttribute('disabled') : (submitButton.disabled = true);
};
export const initCaptchas = () => {
    const captchaContainers = document.querySelectorAll('.captcha-container');
    if (captchaContainers.length === 0) {
        return;
    }
    const containersWithoutRequired = Array.from(captchaContainers).filter((element) => !element.classList.contains('captcha-required'));
    const captchaRequiredPromise = containersWithoutRequired.length === 0
        ? new Promise((resolve) => {
            resolve({});
        })
        : new Promise(async (resolve) => {
            const response = await fetch(window.endpoints.captchaRequired);
            resolve(await response.json());
        });
    const importPromise = import('friendly-challenge');
    Promise.all([captchaRequiredPromise, importPromise]).then((results) => {
        const friendlyCaptcha = results[1];
        captchaContainers.forEach((captchaContainer, key) => {
            const captchaType = captchaContainer.dataset.captchaType || 'form';
            const captchaRequired = results[0][captchaType];
            if (!captchaContainer.classList.contains('captcha-required') && !captchaRequired) {
                return;
            }
            captchaContainer.id = 'captcha-container-' + key.toString();
            const captchaOptions = {
                sitekey,
                puzzleEndpoint,
                language: navigator.language.substring(0, 2),
                startMode: 'focus',
                solutionFieldName: solutionFieldName,
                doneCallback: () => {
                    captchaSolvedCallback(captchaContainer);
                },
            };
            captchaWidgets.set(captchaContainer.id, new friendlyCaptcha.WidgetInstance(captchaContainer, captchaOptions));
            toggleSubmitButton(captchaContainer, false);
        });
    });
};
export const generateCaptchaSolution = () => {
    return new Promise((resolve, reject) => {
        import('friendly-challenge').then((friendlyCaptcha) => {
            const captchaContainer = document.createElement('div');
            const captchaOptions = {
                sitekey,
                puzzleEndpoint,
                startMode: 'auto',
                doneCallback: (solution) => {
                    resolve(solution);
                },
                errorCallback: () => {
                    reject();
                },
                language: window.language,
                readyCallback: () => { },
                startedCallback: () => { },
                forceJSFallback: false,
                skipStyleInjection: true,
                solutionFieldName: 'doesntmatter',
                styleNonce: '',
            };
            new friendlyCaptcha.WidgetInstance(captchaContainer, captchaOptions);
        });
    });
};
export const initRecaptcha = async () => {
    if (recaptchaLoaded) {
        return;
    }
    await getScript('https://www.recaptcha.net/recaptcha/api.js?render=' + recaptchaSiteKey);
    recaptchaLoaded = true;
};
export const getRecaptchaToken = async () => {
    if (!recaptchaLoaded || typeof window.grecaptcha === 'undefined') {
        await initRecaptcha();
        if (!recaptchaLoaded || typeof window.grecaptcha === 'undefined') {
            return null;
        }
    }
    return new Promise(async (resolve) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then((token) => {
                resolve(token);
            });
        });
    });
};
